
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 70 70","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"70","height":"70","rx":"35","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M45.517 25.131L49.647 21l1.443 1.442-27.01 27.01-1.442-1.442 9.588-9.55c-1.364.469-2.611 1.248-3.703 2.34l-3.508-3.508a14.8 14.8 0 0112.55-4.21l4.093-4.092c-6.86-2.26-14.694-.663-20.15 4.794L18 30.276c7.444-7.444 18.435-9.12 27.517-5.145zM32.03 44.306l.506-.506c1.949-1.443 4.716-1.287 6.47.467L35.5 47.775l-3.468-3.469zm6.08-6.08a9.77 9.77 0 014.365 2.533l3.508-3.507a14.55 14.55 0 00-4.053-2.885l-3.82 3.859zm7.484-7.481l3.586-3.586A24.288 24.288 0 0153 30.277l-3.509 3.508c-1.208-1.208-2.494-2.222-3.897-3.04z","fill":"#EB5757"}})])
          )
        }
      }
    